export default "__VITE_ASSET__BwBYOS$H__"